<template>
  <server-list
    :key="tableRenderKey"
    :request-func="organizationList"
    search-placeholder="Пошук за назвою, кодом або ЄДРПОУ...">
    <template #action-button>
      <v-btn @click="openCreateDialog">
        <v-icon class="mr-1">mdi-plus</v-icon>
        <span>Створити організацію</span>
      </v-btn>
    </template>
    <template #items="{ items }">
      <v-row>
        <v-col
          v-for="item in items as Organization[]"
          :key="item.id"
          cols="12"
          md="6">
          <v-hover>
            <template #default="{ isHovering, props }">
              <v-card
                :elevation="isHovering ? 2 : 0"
                border
                class="rounded-lg"
                v-bind="props"
                variant="flat">
                <v-card-text class="pa-4">
                  <div class="d-flex justify-space-between align-start mb-4">
                    <div class="d-flex align-center">
                      <v-avatar
                        class="me-3"
                        color="blue-lighten-5"
                        rounded="lg"
                        size="48">
                        <v-icon color="primary">mdi-briefcase-outline</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-h6 font-weight-bold">
                          {{ item.name || '---' }}
                        </div>
                        <div class="font-size-12 text-grey">
                          {{ item.description || 'Опис відсутній' }}
                        </div>
                      </div>
                    </div>

                    <v-chip
                      :color="item.isActive ? 'success' : 'error'"
                      class="font-weight-bold"
                      variant="tonal">
                      <span class="font-weight-bold">{{
                        item.isActive ? 'Активна' : 'Неактивна'
                      }}</span>
                    </v-chip>
                  </div>

                  <v-row class="mb-4" dense>
                    <v-col cols="6">
                      <div class="font-size-12 text-grey">ЄДРПОУ</div>
                      <div class="font-size-14">
                        {{ item.edrpou || 'Відсутній' }}
                      </div>
                    </v-col>
                    <v-col cols="6">
                      <div class="font-size-12 text-grey">Код</div>
                      <div class="font-size-14">
                        {{ item.code || 'Відсутній' }}
                      </div>
                    </v-col>
                    <v-col class="mt-2" cols="6">
                      <div class="font-size-12 text-grey">Телефон</div>
                      <div class="font-size-14">
                        {{ item.phone || 'Відсутній' }}
                      </div>
                    </v-col>
                    <v-col class="mt-2" cols="6">
                      <div class="font-size-12 text-grey">Email</div>
                      <div class="font-size-14 text-primary">
                        {{ item.email || 'Відсутня' }}
                      </div>
                    </v-col>
                    <v-col class="mt-2" cols="12">
                      <div class="font-size-12 text-grey">Адреса</div>
                      <div class="font-size-14 text-primary">
                        {{ item.address || 'Відсутня' }}
                      </div>
                    </v-col>
                  </v-row>

                  <v-divider class="mb-4"></v-divider>

                  <div class="d-flex justify-space-between align-center">
                    <div class="text-body-2">
                      <span class="text-grey">Підрозділів:</span>
                      <span class="font-weight-bold text-blue-darken-3">
                        0
                      </span>
                    </div>
                    <div class="d-flex gap-2">
                      <v-btn
                        class="text-none me-2"
                        style="border-color: #ddd"
                        variant="outlined"
                        @click="openUpdateDialog(item)">
                        <span class="font-weight-medium">Редагувати</span>
                      </v-btn>
                      <v-btn
                        border
                        class="text-none"
                        style="border-color: #ddd"
                        variant="outlined"
                        @click="deleteItem(item)">
                        <span class="font-weight-medium text-error">
                          Видалити
                        </span>
                      </v-btn>
                    </div>
                  </div>
                </v-card-text>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </template>
  </server-list>
</template>

<script lang="ts">
import { ref } from 'vue'
import { deleteOrganization, organizationList } from '@/requests/organization'
import { openDialog } from '@/dialog'
import { confirm } from 'best-modules/plugins'
import { Organization } from '@/utils/types/organization'
import ServerList from '@/components/ServerList.vue'

export default {
  name: 'OrganizationList',
  components: { ServerList },
  methods: { organizationList },
  setup() {
    const tableRenderKey = ref(1)
    const organizations = ref<Organization[]>([])

    const openCreateDialog = () => {
      openDialog({
        name: 'Organization',
        action: 'create',
        params: {
          title: 'Створити організацію',
          submitLabel: 'Створити',
          cb: () => (tableRenderKey.value += 1),
        },
      })
    }

    const openUpdateDialog = (item: Organization) => {
      openDialog({
        name: 'Organization',
        action: 'update',
        params: {
          title: 'Редагувати організацію',
          submitLabel: 'Змінити',
          cb: () => (tableRenderKey.value += 1),
        },
        dialogData: { itemData: item },
      })
    }

    const deleteItem = (item: Organization) => {
      confirm({
        text: `Ви впевнені, що хочете видалити організацію "${item.name}"?`,
      }).then(() => {
        return deleteOrganization(item.id).then(() => {
          tableRenderKey.value += 1
        })
      })
    }

    return {
      openCreateDialog,
      openUpdateDialog,
      deleteItem,
      organizations,
      tableRenderKey,
    }
  },
}
</script>
